// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"adec1ad9","213":"11bc091b","453":"c3db55c9","455":"8de7112f"}[chunkId] + ".chunk.js";
};